import React from 'react';

import Pocket from '../../../components/DataTable/PocketDataTable';

export default function MainVKP() {
    return (
        <Pocket
            type="vkplay" // TODO: переименовать карман
            project="media.vkplay.ru"
            columnsArray={[
                { type: 'type' },
                {
                    type: 'title',
                    accessor: 'entity.title',
                },
                { type: 'edit' },
                { type: 'delete' },
            ]}
            requiredFields={[]}
            formFields={[
                {
                    type: 'storySearch',
                    name: 'storySearch',
                },
                {
                    type: 'input',
                    name: 'name',
                    label: 'Заголовок',
                    maxLength: 100,
                    // isMultilang: true,
                },
                {
                    type: 'textarea',
                    name: 'description',
                    label: 'Лид',
                    maxLength: 200,
                    textareaRows: 4,
                },
            ]}
        />
    );
}
